import { ImageLoader } from "next/image";

// Need to use this in order to hard code the base URL rather than use relative
// This is needed to support hosting the site on a separate domain (e.g. zapier.com/templates)

export const crossDomainImageLoader: ImageLoader = ({
  src,
  width,
  quality,
}) => {
  const url = `${
    process.env.NEXT_PUBLIC_INTERFACES_BASE_URL
  }/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;

  return url;
};
